module.exports = __webpack_public_path__ + "static/media/cardView.017b2847.svg";